// eslint-disable-next-line import/prefer-default-export
export function getLanguages(baseUrl) {
  /**
   * the original link for icons
   * https://icons.iconarchive.com/icons/custom-icon-design/round-world-flags/256/United-kingdom-icon.png
   */

  const LANGUAGES = [
    {
      id: 1,
      name: 'en-GB',
      type: 'language',
      functionArgs: 'en-GB',
      functionName: 'changeLanguage',
      label: 'English',
      icon: `${baseUrl}/CFP2/images/languages/United-kingdom-icon.png`
    },
    {
      id: 2,
      name: 'ms',
      type: 'language',
      functionArgs: 'ms',
      functionName: 'changeLanguage',
      label: 'Malay',
      icon: `${baseUrl}/CFP2/images/languages/Malaysia-icon.png`
    },
    {
      id: 3,
      name: 'zh-Hans',
      type: 'language',
      functionArgs: 'zh-Hans',
      functionName: 'changeLanguage',
      label: 'Chinese', // Chinese Simplified
      icon: `${baseUrl}/CFP2/images/languages/China-icon.png`
    },
    {
      id: 4,
      name: 'ta',
      type: 'language',
      functionArgs: 'ta',
      functionName: 'changeLanguage',
      label: 'Tamil',
      icon: `${baseUrl}/CFP2/images/languages/India-icon.png`
    },
    {
      id: 7,
      name: 'fr',
      type: 'language',
      functionArgs: 'fr',
      functionName: 'changeLanguage',
      label: 'French',
      icon: `${baseUrl}/CFP2/images/languages/France-icon.png`
    },
    {
      id: 8,
      name: 'de',
      type: 'language',
      functionArgs: 'de',
      functionName: 'changeLanguage',
      label: 'German',
      icon: `${baseUrl}/CFP2/images/languages/Germany-icon.png`
    },
    {
      id: 9,
      name: 'it',
      type: 'language',
      functionArgs: 'it',
      functionName: 'changeLanguage',
      label: 'Italian',
      icon: `${baseUrl}/CFP2/images/languages/Italy-icon.png`
    },
    {
      id: 10,
      name: 'pl',
      type: 'language',
      functionArgs: 'pl',
      functionName: 'changeLanguage',
      label: 'Polish',
      icon: `${baseUrl}/CFP2/images/languages/Poland-icon.png`
    },
    {
      id: 11,
      name: 'pt',
      type: 'language',
      functionArgs: 'pt',
      functionName: 'changeLanguage',
      label: 'Portuguese',
      icon: `${baseUrl}/CFP2/images/languages/Portugal-icon.png`
    },
    {
      id: 12,
      name: 'ru',
      type: 'language',
      functionArgs: 'ru',
      functionName: 'changeLanguage',
      label: 'Russian',
      icon: `${baseUrl}/CFP2/images/languages/Russia-icon.png`
    },
    {
      id: 13,
      name: 'es',
      type: 'language',
      functionArgs: 'es',
      functionName: 'changeLanguage',
      label: 'Spanish',
      icon: `${baseUrl}/CFP2/images/languages/Spain-icon.png`
    },
    {
      id: 14,
      name: 'zh-Hant',
      type: 'language',
      functionArgs: 'zh-Hant',
      functionName: 'changeLanguage',
      label: 'Chinese', // Chinese Traditional
      icon: `${baseUrl}/CFP2/images/languages/China-icon.png`
    },
    {
      id: 15,
      name: 'ja',
      type: 'language',
      functionArgs: 'ja',
      functionName: 'changeLanguage',
      label: 'Japanese',
      icon: `${baseUrl}/CFP2/images/languages/Japan-icon.png`
    },
    {
      id: 16,
      name: 'tr',
      type: 'language',
      functionArgs: 'tr',
      functionName: 'changeLanguage',
      label: 'Turkish',
      icon: `${baseUrl}/CFP2/images/languages/Turkey-icon.png`
    },
    {
      id: 17,
      name: 'el',
      type: 'language',
      functionArgs: 'el',
      functionName: 'changeLanguage',
      label: 'Greek',
      icon: `${baseUrl}/CFP2/images/languages/Greece-icon.png`
    },
    {
      id: 18,
      name: 'hu',
      type: 'language',
      functionArgs: 'hu',
      functionName: 'changeLanguage',
      label: 'Hungarian',
      icon: `${baseUrl}/CFP2/images/languages/Hungary-icon.png`
    },
    {
      id: 19,
      name: 'ro',
      type: 'language',
      functionArgs: 'ro',
      functionName: 'changeLanguage',
      label: 'Romanian',
      icon: `${baseUrl}/CFP2/images/languages/Romania-icon.png`
    },
    {
      id: 20,
      name: 'th',
      type: 'language',
      functionArgs: 'th',
      functionName: 'changeLanguage',
      label: 'Thai',
      icon: `${baseUrl}/CFP2/images/languages/Thailand-icon.png`
    },
    {
      id: 21,
      name: 'ko',
      type: 'language',
      functionArgs: 'ko',
      functionName: 'changeLanguage',
      label: 'Korean',
      icon: `${baseUrl}/CFP2/images/languages/South-Korea-icon.png`
    },
    {
      id: 22,
      name: 'nl',
      type: 'language',
      functionArgs: 'nl',
      functionName: 'changeLanguage',
      label: 'Dutch',
      icon: `${baseUrl}/CFP2/images/languages/Netherlands-icon.png`
    },
    {
      id: 23,
      name: 'cy',
      type: 'language',
      functionArgs: 'cy',
      functionName: 'changeLanguage',
      label: 'Welsh',
      icon: `${baseUrl}/CFP2/images/languages/Wales-icon.png`
    },
    {
      id: 24,
      name: 'ga',
      type: 'language',
      functionArgs: 'ga',
      functionName: 'changeLanguage',
      label: 'Irish',
      icon: `${baseUrl}/CFP2/images/languages/Ireland-icon.png`
    },
    {
      id: 25,
      name: 'ht',
      type: 'language',
      functionArgs: 'ht',
      functionName: 'changeLanguage',
      label: 'Haitian Creole',
      icon: `${baseUrl}/CFP2/images/languages/Haiti-icon.png`
    },
    {
      id: 26,
      name: 'sv',
      type: 'language',
      functionArgs: 'sv',
      functionName: 'changeLanguage',
      label: 'Swedish',
      icon: `${baseUrl}/CFP2/images/languages/Sweden-icon.png`
    }
  ];

  return LANGUAGES;
}
